import {connect} from "redux-vue";
import SlideTemplate from "./SlideTemplate";
import * as locationActions from "../actions/location";
import * as locationsActions from "../actions/locations";
import * as stakeholderActions from "../actions/stakeholder";
import LocationItem from "../components/LocationItem";

const StakeholdersSlide = {
  props: ['locations', 'action', 'actions', 'fetchLocations', 'setLocation', 'setStakeholder'],

  mounted() {
    this.fetchLocations();
    tippy('[data-tippy-content]', {
      placement: 'bottom'
    });
  },

  watch: {
    'action.errorMessageHTML'(val, prev) {
      if (val !== prev) {
        this.$nextTick(() => {
          tippy('[data-tippy-content]', {
            placement: 'bottom'
          });
        })
      }
    },
    'action.successMessageHTML'(val, prev) {
      if (val !== prev) {
        this.$nextTick(() => {
          tippy('[data-tippy-content]', {
            placement: 'bottom'
          });
        })
      }
    }
  },

  methods: {
    /**
     *
     * @param location
     * @param stakeholder
     * @returns {Function}
     */
    showMoreInformation(location, stakeholder = null) {
      return () => {
        this.setLocation(location);
        this.setStakeholder(stakeholder)
      }
    }
  },

  /**
   *
   * @param h
   * @returns {*}
   */
  render(h) {
    return (
      <SlideTemplate key={this.locations.collection.length}>
        <div class="p-6 lg:px-12">
          <p class="text-brand-gray-500 mb-3 leading-none lg:whitespace-no-wrap">
            <strong class="mr-1">Stakeholders</strong>
            <small>(Select each person in the Stakeholders view to review additional information, select Take Action
              from the top menu to continue.)
            </small>
          </p>

          <ul class="flex flex-wrap -m-1">
            {this.locations.collection.map(each => (
              <li key={each.id} class="w-full lg:w-1/2 p-1 relative">
                <LocationItem key={each.adoption} location={each}/>
              </li>
            ))}
          </ul>
        </div>
      </SlideTemplate>
    );
  }
};

function mapStateToProps(state) {
  return {
    action: state.simulation.action,
    actions: state.simulation.actions,
    locations: state.simulation.locations,
  };
}

function mapActionToProps(dispatch) {
  return {
    fetchLocations: () => dispatch(locationsActions.fetchLocations()),
    setLocation: (location) => dispatch(locationActions.setLocation(location)),
    setStakeholder: (stakeholder) => dispatch(stakeholderActions.setStakeholder(stakeholder)),
  };
}

export default connect(mapStateToProps, mapActionToProps)(StakeholdersSlide);
